(async () => {
  if (!customElements.get("product-animations")) {
    const { default: Swiper, EffectFade, Mousewheel } = await import("swiper");
    Swiper.use([EffectFade, Mousewheel]);
    class ProductAnimations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector("[data-product-animations-swiper]");
        const self = this;

        this.swiperOptions = {
          loop: false,
          observer: true,
          threshold: 10,
          slidesPerView: 1,
          direction: "vertical",
          speed: 750,
          grabCursor: true,
          effect: "fade",
          fadeEffect: {
            crossFade: true,
          },
          mousewheel: {
            sensitivity: 1,
            forceToAxis: true,
          },
          on: {
            slideChangeTransitionStart: function (swiper) {
              // add the offset top as a swiper attribute
              swiper.offsetTop = self.getOffsetTop();
            },
            slideChange: function (swiper) {
              swiper.params.mousewheel.releaseOnEdges = false;
              swiper.params.touchReleaseOnEdges = false;
              window.scrollTo({
                top: swiper.offsetTop,
                behavior: "smooth",
              });
            },
            reachBeginning: function (swiper) {
              setTimeout(function () {
                swiper.params.mousewheel.releaseOnEdges = true;
                swiper.params.touchReleaseOnEdges = true;
              }, 1000);
            },
            reachEnd: function (swiper) {
              setTimeout(function () {
                swiper.params.mousewheel.releaseOnEdges = true;
                swiper.params.touchReleaseOnEdges = true;
              }, 1000);
            },
          },
        };

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions,
            };
          }
        }

        this.init();

        // re-init slider when Theme Editor is active
        if (Shopify.designMode && this.swiperInstance) {
          const sectionSettings = JSON.parse(
            this.closest("[data-shopify-editor-section]").dataset.shopifyEditorSection,
          );

          // Update the swiper
          window.addEventListener("shopify:section:load", () => {
            this.swiperInstance.update();
          });

          // Slide to the slide when a specific block is selected
          window.addEventListener("shopify:block:select", (event) => {
            if (event.detail.sectionId === sectionSettings.id) {
              // extra check to see if we're in the right section, because the event listener is added to the window and might fire for multiple sections.
              this.handleSectionEvents(event);
            }
          });
        }
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }

      /**
       * Handles the theme editor block change/edit event
       * @param {Object} event
       */
      handleSectionEvents(event) {
        // Slide to slide based on the data attribute from the target and add 1 to get the slide index
        this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex));
      }

      /**
       * The top value of the element + half the window height, so it's scrolled into the center of the screen, using scrollTo instead of scrollIntoView to support Safari browsers.
       * @returns integer
       */
      getOffsetTop() {
        const thisElementHeight = this.getBoundingClientRect().height;
        let setOffsetTop = this.offsetTop;
        if (thisElementHeight < window.innerHeight) {
          setOffsetTop = this.offsetTop - (window.innerHeight - thisElementHeight) / 2;
        }
        return setOffsetTop;
      }
    }

    window.ProductAnimations = ProductAnimations;

    customElements.define("product-animations", ProductAnimations);
  }
})();
